import { render, staticRenderFns } from "./displayGoods.vue?vue&type=template&id=30318678&scoped=true"
import script from "./displayGoods.vue?vue&type=script&lang=js"
export * from "./displayGoods.vue?vue&type=script&lang=js"
import style0 from "./displayGoods.vue?vue&type=style&index=0&id=30318678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30318678",
  null
  
)

export default component.exports